@if (!disableBackToAssign) {
  <div
    class="back-to-assign-btn"
    role="button"
    (click)="backToAssign()"
    [ngClass]="{ 'back-to-assign-btn__order': order, labeled: label }">
    @if (!loading) {
      <img
        matTooltip="Move back to assign"
        matTooltipClass="pdq-mat-tooltip"
        src="/assets/images/print/back_icon.svg"
        alt="" />
    }
    @if (loading) {
      <mat-spinner [diameter]="17"></mat-spinner>
    }
    @if (label) {
      <span class="label">{{ label }}</span>
    }
  </div>
}

@if (disableBackToAssign) {
  <div
    class="back-to-assign-btn__disable"
    role="button"
    [ngClass]="{ 'back-to-assign-btn__order': order, labeled: label }">
    <img
      matTooltip="it's too late to reassign this batch"
      matTooltipClass="pdq-mat-tooltip"
      src="/assets/images/print/back_icon.svg"
      alt="" />
    @if (label) {
      <span class="label">{{ label }}</span>
    }
  </div>
}
